import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Юбка-карандаш, пожалуй, наиболее женственный крой из всех. Благодаря интригующему разрезу сзади юбка удобна в носке и не сковывает движения. Приятная, плотная и скользящая ткань позволяет чувствовать себя комфортно в любую погоду и время года. Печать осуществляется на всей поверхности юбки, включая резинку, на которой она крепится.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`full_print_pencil_skirt`],
      sizeInfo: `pencil_skirt`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
